import React from 'react';
import PropTypes from 'prop-types';
import { Input, Label } from 'reactstrap';
import './Radio.scss';
import classnames from 'classnames';

const Radio = (props) => {
  const {
    name, id, onBlur, onChange, value, checked, className,
  } = props;
  return (
    <div className={classnames(className, 'radio')}>
      <div className="radio__wrapper">
        <Input
          type="radio"
          name={name}
          id={id}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          checked={checked}
          className=""
        />
        <Label className=" pr-2" htmlFor={id}>
          {value}
        </Label>
      </div>
    </div>
  );
};
Radio.defaultProps = {
  className: '',
};

Radio.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
};

export default Radio;
